import type { StoreApi, UseBoundStore } from 'zustand';
import { createSelectors } from '../../../utils/state/zustand';
import type { DataSourceRecordStoreType } from './types';

type DataSourceRecordStoreWithSubscribeSelector = UseBoundStore<
  StoreApi<DataSourceRecordStoreType> & {
    subscribe: <T>(
      selector: (state: DataSourceRecordStoreType) => T,
      listener: (selectedState: T, previousSelectedState: T) => void,
      options?: { equalityFn?: (a: T, b: T) => boolean },
    ) => () => void;
  }
>;

export const createDataSourceRecordStoreSelectors = (
  store: DataSourceRecordStoreWithSubscribeSelector,
) => {
  const selectorsStore = createSelectors(store);
  // preserve the enhanced subscribe method from the original store (like InterfaceStore does)
  return Object.assign(store, {
    hooks: selectorsStore.hooks,
  });
};
